import { makeStyles, createStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    modalTitle: {
      marginTop: '26px',
      marginBottom: '85px',
      marginLeft: '23px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 18,
      lineHeight: '21px',
      color: '#2C2D3E',
    },
    leftText: {
      marginBottom: '8px',
      position: 'relative',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 14,
      lineHeight: '17px',
      color: '#2C2D3E',
      marginLeft: '50px',
    },
    rightText: {
      marginBottom: '8px',
      position: 'relative',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 14,
      lineHeight: '16px',
      color: '#2C2D3E',
      verticalAlign: 'center',
      marginLeft: '50px',
    },
    line: {
      position: 'relative',
      width: '687px',
      size: '0px',
      color: '#2c2d3e',
      opacity: 0.3,
      display: 'inline-block',
      align: 'center',
      marginBottom: '18px',
    },
    editUserButton: {
      width: '147px',
      marginLeft: '530px',
      marginTop: '85px',
      padding: '0px 0px 0px 0px',
      fontSize: 14,
      height: '36px',
      left: '59px',
      border: 'solid 1px #3C419A',
      color: '#3C419A',
      backgroundColor: '#FFFFFF',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: '#FFFFFF',
      },
    },
  }),
);

export const styles = () =>
  createStyles({
    root: {
      height: '586px',
      width: '768px',
      margin: 0,
      padding: 0,
    },
  });
